// extracted by mini-css-extract-plugin
export default {"imageWrapper":"styles_imageWrapper__gob1y"};